import React from "react";
import { Container, Box, Link } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import BottomToolbar from "./BottomToolbar";
import PageHeader from "./PageHeader";
import { T } from "./Translate";
import { pageContentSx } from "../pageLayout";

// Página pública (sin login) que Google Play exige como "URL de eliminación
// de cuenta" en Seguridad de los datos. Lo que dice que se borra o se
// conserva tiene que coincidir con functions/accountDeletion.js.
const DeleteAccount = () => {
  return (
    <Container maxWidth={false} disableGutters sx={pageContentSx}>
      <PageHeader title={<T>Eliminar cuenta</T>} />
      <Container sx={{ mt: "16px", mb: 16 }}>
        <Container
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "flex-start",
            width: "100%",
            textAlign: "left",
          }}
        >
          <Box>
            <h1><T>Cómo eliminar tu cuenta de Notiline</T></h1>

            <p>
              <T>Notiline es una app de Dapur Tecnología. Podés eliminar tu cuenta y los
              datos asociados en cualquier momento, sin costo.</T>
            </p>

            <h2><T>Desde la app</T></h2>
            <ol>
              <li><T>Abrí Notiline e iniciá sesión.</T></li>
              <li><T>Entrá a Ajustes desde el menú de tu cuenta.</T></li>
              <li><T>Tocá "Eliminar cuenta" y confirmá.</T></li>
            </ol>
            <p>
              <T>Si la app te pide volver a iniciar sesión por seguridad, hacelo y repetí
              el paso 3. Si tenés una suscripción paga, cancelala antes desde la sección
              Suscripción para que PayPal no te siga cobrando.</T>
            </p>

            <h2><T>Si no podés entrar a la app</T></h2>
            <p>
              <T>Escribinos a</T>{" "}
              <Link href="mailto:support@notiline.com?subject=Eliminar%20mi%20cuenta">support@notiline.com</Link>{" "}
              <T>desde el email con el que te registraste, con el asunto "Eliminar mi
              cuenta". Vamos a eliminarla dentro de los 30 días y te avisaremos por email.</T>
            </p>

            <h2><T>Qué datos se eliminan</T></h2>
            <p><T>Al eliminar la cuenta se borran de forma permanente:</T></p>
            <ul>
              <li><T>Tu acceso a la cuenta: email, contraseña, llaves de acceso y verificación en dos pasos.</T></li>
              <li><T>Tu perfil: nombre, nombre de usuario, teléfono, foto, localidad y registros de acceso.</T></li>
              <li><T>Tus publicaciones: ofertas, eventos, hilos, comentarios, tiendas y sus productos, locales de Pedidos y su menú, autos, propiedades y viajes, con sus imágenes y videos.</T></li>
              <li><T>Tus preguntas y respuestas, estados, notificaciones y los mensajes de chat que enviaste.</T></li>
              <li><T>Tus listas: guardados, me gusta, ocultos, bloqueados, seguidores y cuentas que seguís.</T></li>
            </ul>
            <p>
              <T>El borrado se completa en minutos, salvo las copias de seguridad
              automáticas de la infraestructura, que se eliminan en un plazo máximo de 30 días.</T>
            </p>

            <h2><T>Qué datos se conservan</T></h2>
            <ul>
              <li>
                <T>Registros de pagos, compras, ventas, comisiones, suscripciones y facturas:
                se conservan hasta 10 años, porque la normativa fiscal y contable nos obliga
                a guardarlos.</T>
              </li>
              <li>
                <T>Pedidos de comida y súper: se conservan como registro de compra, hasta 10
                años, con los productos, el total y la forma de pago. Los que hiciste quedan sin
                tu nombre, dirección, teléfono, notas ni ubicaciones. Los que recibió tu local
                conservan su nombre, pero no su dirección, alias ni ubicación. Los pedidos en
                curso se cierran.</T>
              </li>
              <li>
                <T>Denuncias de contenido y mensajes enviados a soporte: se conservan hasta
                2 años para prevenir fraude y abuso.</T>
              </li>
            </ul>

            <h2><T>Borrar solo una parte de tus datos</T></h2>
            <p>
              <T>Sin eliminar la cuenta, podés borrar tus publicaciones desde la app o editar
              tu perfil desde Editar Perfil. Para pedir el borrado de otros datos, escribinos
              a</T>{" "}
              <Link href="mailto:support@notiline.com">support@notiline.com</Link>.
            </p>

            <p>
              <T>Más información en la</T>{" "}
              <Link component={RouterLink} to="/privacyPolicy"><T>Política de privacidad</T></Link>.
            </p>
          </Box>
        </Container>
      </Container>
      <BottomToolbar />
    </Container>
  );
};

export default DeleteAccount;
